<template>
  <v-card class="recharge mw-700 mx-auto" elevation="0">
    <div v-if="!successData">
      <v-form ref="form" @submit.prevent="validate" lazy-validation>
        <v-row>
          <v-col cols="12" sm="8" align-self="center">
            <h1 class="mw-300">
              <span class="d-block">
                {{ $t('recharge.with') }}
              </span>
              {{ $t('recharge.card.title') }}
            </h1>
          </v-col>
          <v-col cols="12" sm="4" align-self="center">
            <HAmount @input="getAmount" :minAmount="200" class="ml-auto" />
          </v-col>
        </v-row>

        <v-divider class="my-10" />

        <RechargeCardFields />

        <v-divider class="my-10" />

        <RechargePersonalFields />

        <div
          class="mt-5"
          :class="{
            'text-right': !$vuetify.breakpoint.xsOnly,
            'text-center': $vuetify.breakpoint.xsOnly,
          }"
        >
          <v-btn
            @click="setRechargeFields({ type: null })"
            :disabled="isLoading"
            :class="{ 'mb-5': $vuetify.breakpoint.xsOnly }"
            :block="$vuetify.breakpoint.xsOnly"
            class="mr-5"
            color="grey"
            elevation="0"
            large
            text
          >
            <v-icon left> mdi-chevron-left </v-icon>
            {{ $t('recharge.navigation.goBack') }}
          </v-btn>

          <v-btn
            @click="validate"
            :loading="isLoading"
            :block="$vuetify.breakpoint.xsOnly"
            color="primary"
            elevation="0"
            large
          >
            {{ $t('recharge.card.withCard') }}
          </v-btn>
        </div>
      </v-form>
    </div>

    <RechargeSuccess v-else />
  </v-card>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'

import HAmount from '@/components/app/HAmount'
import RechargeCardFields from './formFields/RechargeCardFields'
import RechargePersonalFields from './formFields/RechargePersonalFields'
import RechargeSuccess from './formFields/RechargeSuccess.vue'

export default {
  name: 'RechargeByCard',

  components: {
    HAmount,
    RechargeCardFields,
    RechargePersonalFields,
    RechargeSuccess,
  },

  computed: {
    ...mapGetters(['isLoading', 'successData']),
  },

  methods: {
    ...mapActions(['handleRecharge']),
    ...mapMutations(['setRechargeFields']),

    validate() {
      if (this.$refs.form.validate()) {
        this.handleRecharge()
      }
    },

    getAmount(value) {
      this.setRechargeFields({ value })
    },
  },
}
</script>
